<template>
  <div class="content-box">
    <div class="support-index">
      <div class="support-tickets">
        <div class="support-tickets-header">
          <div class="tickets-control">
            <h5>Tickets</h5>
            <div class="element-search">
              <input placeholder="Type to filter tickets..." type="text" />
            </div>
          </div>
          <div class="tickets-filter">
            <div class="form-group mr-3">
              <label class="d-none d-md-inline-block mr-2">Estado</label>
              <select class="form-control-sm">
                <option>Abiertas</option>
                <option>Cerradas</option>
              </select>
            </div>
            <div class="form-group mr-1">
              <label class="d-none d-md-inline-block mr-2">Asignado a:</label>
              <select class="form-control-sm">
                <option>John Mayers</option>
                <option>Phil Collins</option>
                <option>Ray Donovan</option>
              </select>
            </div>
          </div>
        </div>
        <TareaTicketComponent
          v-for="current in data.results"
          v-bind:key="current.id"
          :current="current"
          @onTicketClick="ticketClick"
        />
        
        <div class="load-more-tickets" @click="onPageChange(currentPage + 1)">
          <a href="#">
            <span>Cargar Más...</span>
          </a>
        </div>
      </div>
      <TareaContentComponent v-if="tareaSeleccionada != null" :current="tareaSeleccionada" />
    </div>
  </div>
</template>

<script>

import TareasService from "@/services/tareas/TareasService";
import TareaTicketComponent from "@/components/tareas/TareaTicketComponent";
import TareaContentComponent from "@/components/tareas/TareaContentComponent";

export default {
  components: {
    TareaTicketComponent,
    TareaContentComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "A",
      data: [],
      tareaSeleccionada: null
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filtro_estado
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      TareasService.fetch(params).then(res => {
        if (self.data.results != null && self.data.results.length > 0) {
          let results = self.data.results;
          self.data = res.data;
          results = results.concat(self.data.results);
          self.data.results = results;
        } else {
          self.data = res.data;
          if (self.data.results.length > 0) {
            self.tareaSeleccionada = self.data.results[0];
          }
        }
      });
    },
    showModalEdit() {},
    truncate(text, length, suffix) {
      if (text === undefined || text === null || text == "") {
        return "";
      }
      return text.substring(0, length) + suffix;
    },
    ticketClick(current) {
      this.tareaSeleccionada = current;
    },
    
  }
};
</script>
